import React, { useEffect, useState } from "react";
import styled from "styled-components";

import PerfilUtils from "../utils/perfil.utils";
import StatusUtils from "../utils/status.utils";

import Divider from "@mui/material/Divider";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import ContentCut from "@mui/icons-material/ContentCut";
import ContentCopy from "@mui/icons-material/ContentCopy";
import ContentPaste from "@mui/icons-material/ContentPaste";
import PendingIcon from "@mui/icons-material/Pending";
import PeopleIcon from "@mui/icons-material/People";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import CheckIcon from "@mui/icons-material/Check";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";
import Cloud from "@mui/icons-material/Cloud";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import getCookie from "../utils/getCookie";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";

const MenuContainer = styled.aside`
  position: absolute;
  top: 64px;
  left: 0;
  bottom: 0;
  width: 320px;
  background-color: #eeeeee;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const Menu = (props) => {
  const { logged } = props;
  const [openDialogExportarCDL, setOpenDialogExportarCDL] = useState(false);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [naoProcessadoCount, setNaoProcessadoCount] = useState({
    count: 0,
    id: "",
  });
  const [aguardandoUnidadeCount, setAguardandoUnidadeCount] = useState({
    count: 0,
    id: "",
  });
  const [confirmado, setConfirmado] = useState({ count: 0, id: "" });
  const [adicionadoSpcCount, setAdicionadoSpcCount] = useState({
    count: 0,
    id: "",
  });
  const [pendenteRemocaoCount, setPendenteRemocaoCount] = useState({
    count: 0,
    id: "",
  });
  const [removidoCount, setRemovidoCount] = useState({ count: 0, id: "" });
  const [canceladoCount, setCanceladoCount] = useState({ count: 0, id: "" });
  const [comInconsistenciasCount, setComInconsistenciasCount] = useState({
    count: 0,
    id: "",
  });

  const [processadoPelaCDL, setProcessadoPelaCDL] = useState({ count: 0, id: "" });
  const [atualizacao, setAtualizacao] = useState(null);

  function exportarDadosCDL() {
    const win = window.open(`${process.env.REACT_APP_DOMAIN_API}/api/relatorio/cdl/${dataInicio}/${dataFim}/${getCookie('_token_spc_manager')}`, '_blank');
    setTimeout(() => {
      win?.close();
    }, 1000);
  }

  useEffect(() => {
    function carregarRegistros() {
      const token = getCookie("_token_spc_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/count/`,
        params
      ).then((response) => {
        const { status } = response;
        response.json().then((data) => {
          if (status === 401) {
          } else if (status === 200) {
            const { logService } = data;

            setAtualizacao(logService);

            for (let index = 0; index < data.data.length; index++) {
              if (data.data[index].nome === StatusUtils["Não Processado"]) {
                setNaoProcessadoCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (
                data.data[index].nome ===
                StatusUtils["Aguardando Confirmação da Unidade"]
              ) {
                setAguardandoUnidadeCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (
                data.data[index].nome === StatusUtils["Confirmado pela Unidade"]
              ) {
                setConfirmado({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (data.data[index].nome === StatusUtils["Adicionado ao SPC"]) {
                setAdicionadoSpcCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (
                data.data[index].nome ===
                StatusUtils["Pendente de Remoção do SPC"]
              ) {
                setPendenteRemocaoCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (data.data[index].nome === StatusUtils.Cancelado) {
                setCanceladoCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (data.data[index].nome === StatusUtils["Removido do SPC"]) {
                setRemovidoCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (
                data.data[index].nome === StatusUtils["Com inconsistências"]
              ) {
                setComInconsistenciasCount({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }

              if (
                data.data[index].nome === StatusUtils["Processado pela CDL"]
              ) {
                setProcessadoPelaCDL({
                  count: data.data[index].qtd,
                  id: data.data[index].id,
                });
              }
            }
          }
        });
      });
    }

    carregarRegistros();

    setInterval(() => {
      carregarRegistros();
    }, [5000]);
  }, []);

  return (
    <MenuContainer>
      <MenuList>
        {logged &&
        (logged.Perfil.nome === PerfilUtils.Administrador ||
          logged.Perfil.nome === PerfilUtils["Contas a Receber"]) ? (
          <>
            <MenuItem
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${naoProcessadoCount.id}`)
              }
            >
              <ListItemIcon>
                <PointOfSaleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Não Processado</ListItemText>
              <div
                style={{
                  width: 32,
                  backgroundColor: "#673AB7",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 11,
                  color: "#D1C4E9",
                }}
              >
                {naoProcessadoCount.count}
              </div>
            </MenuItem>
            <MenuItem
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${aguardandoUnidadeCount.id}`)
              }
            >
              <ListItemIcon>
                <HourglassTopIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Aguardando Unidade</ListItemText>
              <div
                style={{
                  width: 32,
                  backgroundColor: "#3F51B5",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 11,
                  color: "#C5CAE9",
                }}>
                {aguardandoUnidadeCount.count}
              </div>
            </MenuItem>
          </>
        ) : (
          ""
        )}

        {logged && logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() =>
              (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${aguardandoUnidadeCount.id}`)
            }
          >
            <ListItemIcon>
              <HourglassTopIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Aguardando Análise</ListItemText>
            <div
              style={{
                width: 32,
                backgroundColor: "#3F51B5",
                borderRadius: 3,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: 11,
                color: "#C5CAE9",
              }}
            >
              {aguardandoUnidadeCount.count}
            </div>
          </MenuItem>
        ) : (
          ""
        )}

        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${confirmado.id}`)
          }
        >
          <ListItemIcon>
            <DoneAllIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Confirmados</ListItemText>
          <div
            style={{
              width: 32,
              backgroundColor: "#2196F3",
              borderRadius: 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 11,
              color: "#E3F2FD",
            }}
          >
            {confirmado.count}
          </div>
        </MenuItem>

        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${comInconsistenciasCount.id}`)
          }
        >
          <ListItemIcon>
            <AccountBalanceIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Com Inconsistências</ListItemText>
          <div
            style={{
              width: 32,
              backgroundColor: "#9C27B0",
              borderRadius: 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 11,
              color: "#F3E5F5",
            }}
          >
            {comInconsistenciasCount.count}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${adicionadoSpcCount.id}`)
          }
        >
          <ListItemIcon>
            <AccountBalanceIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Adicionado ao SPC</ListItemText>
          <div
            style={{
              width: 32,
              backgroundColor: "#009688",
              borderRadius: 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 11,
              color: "#B2DFDB",
            }}
          >
            {adicionadoSpcCount.count}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${pendenteRemocaoCount.id}`)
          }
        >
          <ListItemIcon>
            <PendingIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Pendente de Remoção</ListItemText>
          <div
            style={{
              width: 32,
              backgroundColor: "#F44336",
              borderRadius: 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 11,
              color: "#FFCDD2",
            }}
          >
            {pendenteRemocaoCount.count}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${removidoCount.id}`)
          }>
          <ListItemIcon>
            <FolderDeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Removido</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${canceladoCount.id}`)
          }
        >
          <ListItemIcon>
            <CancelIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cancelados</ListItemText>
        </MenuItem>

        {logged && 
        logged.Perfil &&
        logged.Perfil.nome === PerfilUtils["Contas a Receber"] ? 
        <MenuItem
          onClick={() => setOpenDialogExportarCDL(true)}
        >
          <ListItemIcon>
            <FileDownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Exportar para CDL</ListItemText>
        </MenuItem> : ''}

        {logged &&
        logged.Perfil &&
        logged.Perfil.nome === PerfilUtils.Administrador ? (
          <>
            <Divider />
            <MenuItem
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/configuracao`)
              }
            >
              <ListItemIcon>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Configurações</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/usuario`)
              }
            >
              <ListItemIcon>
                <PeopleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Usuários</ListItemText>
            </MenuItem>
          </>
        ) : (
          ""
        )}
      </MenuList>

      {atualizacao ? (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 16,
            padding: 8,
            margin: 8,
            border: "1px solid #e0e0e0",
            borderRadius: 5,
            fontSize: 12,
            backgroundColor: "#ffffff",
            boxShadow: "0px 0px 20px -18px #424242",
          }}
        >
          <table>
            <tr>
              <td>Última Atualização: </td>
              {atualizacao.naoAtualizouHoje ? (
                <td
                  style={{
                    backgroundColor: "rgb(244, 67, 54)",
                    color: "rgb(255, 205, 210)",
                    borderRadius: "3px",
                    paddingRight: 4,
                    paddingLeft: 4,
                  }}
                >
                  {atualizacao.updatedAt}
                </td>
              ) : (
                <td
                  style={{
                    backgroundColor: "#000000",
                    color: "#FFFFFF",
                    borderRadius: "3px",
                    paddingRight: 4,
                    paddingLeft: 4,
                  }}
                >
                  {atualizacao.updatedAt}
                </td>
              )}
            </tr>
            <tr>
              <td>Nº Novos Registros: </td>
              <td>{atualizacao.qtdNovosRegistros}</td>
            </tr>
            <tr>
              <td>Nº Registros Atualizados: </td>
              <td>{atualizacao.qtdAtualizados}</td>
            </tr>
            <tr>
              <td>Próxima Atualização: </td>
              <td>{atualizacao.proximaAtualizacao}</td>
            </tr>
          </table>
        </div>
      ) : (
        ""
      )}

      <Dialog
        open={openDialogExportarCDL}
        onClose={() => setOpenDialogExportarCDL(false)}>
        <DialogTitle>Exportar dados para CDL</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Escolha o período de dados que será exportado para a CDL.
          </DialogContentText>
          <table>
            <tr>
              <td><b>Início:</b></td>
              <td><input type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} /></td>
            </tr>
            <tr>
              <td><b>Fim:</b></td>
              <td><input type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} /></td>
            </tr>
          </table>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogExportarCDL(false)}>Cancelar</Button>
          <Button type="button" onClick={exportarDadosCDL}>Exportar</Button>
        </DialogActions>
      </Dialog>
    </MenuContainer>
  );
};

export default Menu;
